const reviewType = [
    { key: "Manufacturers", value: "Manufacturers" },
    { key: "Distributors_Dealers", value: "Distributors/Dealers" },
    { key: "Consultants_ServiceProviders", value: "Consultants/Service Providers" },
    { key: "FranchiseBrands", value: "Franchise Brands" },
];

export { reviewType };
